import { useMutation } from '@apollo/client';
import { useContext } from 'react';
import { AuthContext } from 'routes/auth.context';
import { GRAPHQL_ALTERAR_STATUS_TAXA } from '../../../../gql/taxas';

export const useToggleStatusTaxa = (props) => {
    const { alertConfirm } = useContext(AuthContext);

    const [alterarStatusTaxaMutation, { loading }] = useMutation(GRAPHQL_ALTERAR_STATUS_TAXA, {
        onCompleted: () => {
            alertConfirm({
                tipo: 'sucesso',
                titulo: 'Sucesso',
                conteudo: 'Status da taxa alterado com sucesso!',
            });
            props?.refetch?.();
        },
        onError: (error) => {
            alertConfirm({
                tipo: 'erro',
                titulo: 'Erro',
                conteudo: error.message || 'Erro ao alterar status da taxa',
            });
        },
    });

    const handleToggleStatusTaxa = async (taxa) => {
        const newStatus = taxa.status === 1 ? 0 : 1;

        await alterarStatusTaxaMutation({
            variables: {
                id: taxa.id,
                status: newStatus,
            },
        });
    };

    return {
        handleToggleStatusTaxa,
        loading,
    };
};